import { Component, OnInit, ViewChild } from '@angular/core';
import Player from "@vimeo/player";
import { vPlayer } from 'src/app/models/vPlayer';
import { Course } from 'src/app/models/course';
import { CourseService } from 'src/app/services/course.service';
import { Lesson } from 'src/app/models/lesson';
import { Telemetry } from 'src/app/models/telemetry';
import { Route, ActivatedRoute, Router } from '@angular/router';
import { ScrollService } from 'src/app/services/scroll.service';
import { AccountService } from 'src/app/services/account.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { BasketService } from 'src/app/services/basket.service';
import { forkJoin, BehaviorSubject } from '../../../../node_modules/rxjs';
import { Review } from '../../models/review';
import { iHttpPaginatedResponse } from '../../interfaces/iHttpPaginatedResponse';
import { FileService } from '../../services/file.service';
import { MatDialog } from '@angular/material/dialog';
import { ProgrammeService } from 'src/app/services/programme.service';
import { CourseProgrammeComponent } from 'src/app/components/modals/course-programme/course-programme.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from '../../../environments/environment';
import { TimeZoneService } from 'src/app/services/timezone.service';

@Component({
  selector: 'app-course',
  templateUrl: './course.component.html',
  styleUrls: ['./course.component.scss']
})

export class CourseComponent implements OnInit {
  public vPlayer: vPlayer;
  public course: Course;
  public loading: boolean = true;
  public lessonLoaded: boolean = false;
  public telemetry: BehaviorSubject<Telemetry> = new BehaviorSubject<Telemetry>(new Telemetry);
  public openPanel:number = 0;
  public userCanWatch: boolean = false;
  public lesson_id:number;
  public lesson:Lesson;
  public course_id: number;
  public courseMetaData: any;
  public loggedIn:boolean;
  public allLessonsWatched:BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public quizComplete:BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public completePercent:BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public review: Review;
  public reviewPaginatedResponse: iHttpPaginatedResponse;
  public reviewsLoaded: boolean = false;
  public quizActive: boolean = false;
  public reviewActive: boolean=false;
  public downloadingCertificate: boolean = false;
  public placeholder:string='';
  public watchlistStatus:boolean=false;
  public programmeStatus:boolean=false;
  public relatedCourses:Course[];
  public relatedCoursesLoaded:boolean=false;
  public popularSlideConfig = {
    "slidesToShow": 4,
    "slidesToScroll": 4,
    'arrows': true,
    autoplay: false,
    'responsive': [
      {'breakpoint': 1299, 'settings': { 'slidesToShow': 3, 'slidesToScroll': 3, 'arrows': true} },
      {'breakpoint': 900, 'settings': { 'slidesToShow': 2, 'slidesToScroll': 2, 'arrows': false} },
      {'breakpoint': 600, 'settings': { 'slidesToShow': 1, 'slidesToScroll': 1, 'arrows': false} },
    ]
  };
  public previewClicked:boolean=false;
  public environment = environment;
  public limited:boolean=false;
  public showNotFound:boolean=false;
  public showUnavailable:boolean=false;
  public displayedData: [];
  public itemsPerPage: number = 6;
  public allPages: number;
  // TimeZone
  public DefaultTimeZone:boolean = true;
  public USATimeZone:boolean = false;

  constructor(private courseService: CourseService,
    private route:ActivatedRoute,
    private router: Router,
    private scrollService: ScrollService,
    private accountService: AccountService,
    private authenticationService: AuthenticationService,
    private basketService: BasketService,
    private fileService:FileService,
    private _prog: ProgrammeService,
    public _dialog: MatDialog,
    private _notify: MatSnackBar,
    private timezoneService: TimeZoneService
  )
    {
      if(localStorage.getItem('limitedPractice') && localStorage.getItem('limitedPractice') == '1') this.limited=true;
    this.authenticationService.loggedIn.subscribe(state=>{
      this.loggedIn = state;
    })

    this.vPlayer = new vPlayer;
    this.route.queryParams.subscribe(params => {
      if(params['l']){
        this.lesson_id=params['l'];
      }
    });

    this.route.params.subscribe(res=>{
      this.course_id = res.id;
      if(this.loggedIn){
        this.accountService.checkUserCourseAccess(this.course_id).subscribe(data=>{
          if(data.status=='success'){
            this.userCanWatch=true;
            this.loading=true;
            this.lessonLoaded=false;
            this.previewClicked=false;
            this.getCourse();
          }
        })
      }
    })
  }

  public notify(message:string, action:string) {
    this._notify.open(message, action, {
      duration: 4000,
      verticalPosition: 'top'
    });
  }

  ngOnInit() {
    this.DefaultTimeZone = this.timezoneService.checkDefaultTimeZone();
    this.USATimeZone = this.timezoneService.checkUSATimeZone();
  }

  toggleTrainingProgramme(){
    if (this.programmeStatus) {

    } else {
      const dialogRef = this._dialog.open(CourseProgrammeComponent, {
        width: '450px',
        data: {course:this.course}
      });

      dialogRef.afterClosed().subscribe(res=>{
        if (res) {
          this.notify('Course / Programme status has been updated.','OK');
        }
      });
    }
  }

  toggleWatchlist(){
    if(!this.watchlistStatus){
      this.courseService.addToWatchlist(this.course.id).subscribe(
        (res:any)=>{
          if(res.message=='success') this.watchlistStatus=true;
        }
      );
    }else{
      this.courseService.removeFromWatchlist(this.course.id).subscribe(
        (res:any)=>{
          if(res.message=='success') this.watchlistStatus=false;
        }
      );
    }
  }

  downloadCertificate(){
    if(this.course.meta && this.course.meta.complete){
      this.downloadingCertificate = true;
      this.fileService.downloadFile(`/api/course/certificate/${this.course.id}`).subscribe(data=>{
        var blob = new Blob([data], {type: 'application/pdf'});
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement('a');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none');
        a.setAttribute('target', '_self');
        a.href = url;
        a.download ='certificate.pdf';
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove();
        this.downloadingCertificate = false;
      })
    }
  }

  downloadCertificate2(){
    if(this.course.meta && this.course.meta.complete){
      this.downloadingCertificate = true;
      window.open(environment.apiEndpoint+'/certificatedownload/'+this.course_id+'/'+localStorage.getItem('token'), '_blank');
      this.downloadingCertificate = false;
    };
  }

  public pathUpSupporters(){
    let pathed=[];
    this.course.supporters.forEach((supporter, index)=>{
      if(supporter.supporter && supporter.supporter.image){
        pathed[supporter.supporter.id]=supporter;
        pathed[supporter.supporter.id].supporter.image=this.environment.apiEndpoint+'/storage/supporters/'+supporter.supporter.image;
      }
      // this.course.supporters[index].supporter.image=this.environment.apiEndpoint+'/storage/supporters/'+supporter.supporter.image;
    });
    pathed=pathed.filter(function(el){
      return el != null;
    });
    this.course.supporters=pathed;
  }

  public pathUpTutors(){
    //console.log(this.course.tutors);
    let pathed=[];
    this.course.tutors.forEach((tutor, index)=>{
      if(tutor.tutor && tutor.tutor.image){
        pathed[tutor.tutor.id]=tutor;
        pathed[tutor.tutor.id].tutor.image=this.environment.apiEndpoint+'/storage/tutors/'+tutor.tutor.image;
      }
    });
    pathed=pathed.filter(function(el){
      return el != null;
    });
    this.course.tutors=pathed;
  }

  ngAfterViewInit(){
    this.getCourse();
    this.courseService.getRelatedCourses(this.course_id).subscribe(res=>{
      this.relatedCourses=res;
      this.relatedCoursesLoaded=true;
    });
  }

  getCourse(){
    this.courseService.getCourse(this.course_id, true).subscribe((course:any)=>{
      if (course.status && course.status=='Course not found') {
        this.showNotFound=true;
      } else if(course.status && course.status=='Course unavailable') {
        this.showUnavailable=true;
      } else {
        this.placeholder = course.media.url;
        this.course = course;
        this.getReviews(1);
        this.pathUpSupporters();
        this.pathUpTutors();
        this.fixStreams();
        if(this.loggedIn){
          this.courseService.getCourseMeta(this.course_id).subscribe(metaData=>{
            // console.log('META: ',metaData);
            this.course.meta = metaData.course;
            this.review = new Review(metaData.course.review);

            this.course.lessons.forEach(lesson=>{
              let meta= metaData.lessons.filter(lessonMeta=>{
                return lessonMeta.lesson_id==lesson.id;
              })

              // if (meta[0]) {
                lesson.meta = meta[0];
              // } else {
                // lesson.meta = [];
              // }

            })

            this.checkLessonsCompleted();
            this.loading = false;
            this.loadLesson(null);
          });
          this.courseService.getWatchlistStatus(this.course_id).subscribe(
            (res:any)=>{
              this.watchlistStatus=res.status;
            }
          );
        }
        else{
          this.loading = false;
          this.loadLesson(null);
        }
      }
    });
  }

  fixStreams()
  {
    if(this.course.streams.length){
      this.course.streams=this.course.streams.filter(stream=>{
        return stream.published==1;
      });
    }
  }

  videoComplete(event){
    let numberOfLessons=this.course.lessons.length;
    let lessonsWatched = 0;

    if(event && this.loggedIn){
      this.lesson.meta.watched=true;
      this.courseService.updateLessonMeta(this.lesson.meta).subscribe(meta=>{
        this.checkLessonsCompleted();

        if(this.allLessonsWatched.value) this.showReview();

        // if (numberOfLessons - lessonsWatched != 0) {
        //   let lessonToLoad = numberOfLessons - lessonsWatched;
        //   this.loadLesson(lessonToLoad);
        // }

      })
    }
  }

  checkLessonsCompleted(){
    let numberOfLessons=this.course.lessons.length;
    let lessonsWatched = 0;
    this.course.lessons.forEach(lesson=>{
      // console.log(lesson);
      if(lesson.meta && lesson.meta.watched){
        lessonsWatched++;
      }
    })
    this.completePercent.next(Math.ceil((100/numberOfLessons)*lessonsWatched));
    this.allLessonsWatched.next(lessonsWatched===numberOfLessons);
  }

  loadLesson(lesson_id: number){
    this.lessonLoaded = false;

    this.lesson_id = lesson_id;

    if(!lesson_id){ this.lesson_id=this.course.lessons[0].id; }

    this.lesson = this.course.lessons.filter(lesson=>{
      return lesson.id==this.lesson_id;
    })[0];


    if(this.lesson.free || this.userCanWatch){
      this.vPlayer.options={
        id: this.lesson.vimeo_id,
      };
    }

    if(this.loggedIn && this.lesson.meta){
      this.vPlayer.position=this.lesson.meta.playback_position;
    }

    window.scroll(0, 0);
    setTimeout(()=>{
      this.lessonLoaded = true;
    },100);
  }

  updateTelemetry(telemetry: Telemetry){
    this.telemetry.next(telemetry);

    if(this.loggedIn){
      this.lesson.meta.playback_position = telemetry.playbackPosition;
      this.courseService.updateLessonMeta(this.lesson.meta).subscribe(meta=>{

      })
    }
  }

  goToLesson(lesson: Lesson){
    if(lesson.free || this.userCanWatch){
      this.loadLesson(lesson.id);
      this.toggleQuizOff();
      this.reviewActive=false;
    }
  }

  showReview(){
    this.toggleQuizOff();
    this.reviewActive=true;
    let el = document.getElementById('#contentTarget');
    el.scrollIntoView();
  }

  addToBasket(type){
    this.basketService.add(type,this.course,1);
    this.router.navigate(['/basket']);
  }

  reviewed(review: Review){
    this.review = review;
  }

  getReviews(page){
    this.courseService.getReviews(this.course.id,page).subscribe(res=>{
      this.reviewPaginatedResponse = res;
      this.reviewsLoaded = true;
      this.onPageChange();
      this.allPages = Math.ceil(this.reviewPaginatedResponse.data.length / this.itemsPerPage);
    })
  }

  onPageChange(page: number = 1): void {
    const startItem = (page - 1) * this.itemsPerPage;
    const endItem = page * this.itemsPerPage;
    this.displayedData = this.reviewPaginatedResponse.data.slice(startItem, endItem);
  }

  toggleReview(){
    if(this.allLessonsWatched.value && this.quizActive){
      this.quizActive = false;
    }
  }

  toggleQuiz(){
    if(this.allLessonsWatched.value){
      this.quizActive = (this.quizActive ? false : true);
    }
  }

  toggleQuizOn(){
    if(this.allLessonsWatched.value){
      this.quizActive = true;
      this.reviewActive=false;
      let el = document.getElementById('#contentTarget');
      el.scrollIntoView();
    }
  }

  toggleQuizOff(){
    this.quizActive = false;
  }

  flagQuizComplete(){
    //this.getCourse();
    this.course.meta.complete=true;
  }

}
